import request from "@/CommonDP/utils/request";
import { getContextPath } from "@/CommonDP/utils/index";

export default {
  // 我的项目列表
  getMyProjects(enterpriseId) {
    return request.get(
      `/project/getProjectsByUserId?enterpriseId=${enterpriseId}`
    );
  },
  // 我的项目，排序上移下移
  moveSortProjects(params) {
    return request.post("/project/userCustomPrjOrder/save", params);
  },

  // 项目进度，获得计划数据
  queryPlanList(params) {
    return request.post(`/prj-plan-task/query-tree`, params);
  },

  // 获得项目公告列表
  getNoticeList(params) {
    return request.post("/prjNotice/list", params);
  },

  // 获得项目概况图片
  getOverviewImgs(prjId) {
    return request.get(`/prjCarousel/list?prjId=${prjId}`);
  },
  // 项目概况，关联文件夹
  associatedFolder(prjId, folderId) {
    return request.get(
      `/prjCarousel/associatedFolder?prjId=${prjId}&folderId=${folderId}`
    );
  },
  // 项目概况，获取关联文件夹id
  getAssociatedFolderId(prjId) {
    return request.get(`/prjCarousel/getAssociatedFolder?prjId=${prjId}`);
  },
  // 项目概况，获取关联文件夹位置
  getAssociatedFolderLocation(folderId) {
    return request.get(`/doc/navbar/1/${folderId}`);
  },
  // 项目概况，图片地址
  imgUrl(fileId, fileName, fileVersion) {
    const shareScanUrl =
      location.origin +
      getContextPath() +
      `/doc/share/download/file/content?fileId=${fileId}&fileName=${fileName}&fileVersion=${fileVersion}`;
    return shareScanUrl;
  },

  // 待审,获得待审流程
  getApproveFlows(params, pageSize, pageNo) {
    return request.post(
      `/flow/workbench/myProcessing?pageSize=${pageSize}&pageNum=${pageNo}`,
      params
    );
  },
  // 待审,获得待审计划
  getApproveTasks(params, pageSize, pageNo) {
    return request.post(
      `/prj-plan-task/queryMyCurrentApproveList?pageSize=${pageSize}&pageNo=${pageNo}`,
      params
    );
  }
};
